import AppointmentsAPI from '@/modules/appointments/api/appointments'
import scheduleParticipationDeadlineTransitions from '@/modules/appointments/logic/participationDeadlineScheduler'

let registrationDeadlineRefreshCleanup = null

export default {
  updateAppointments({ commit, dispatch, rootGetters }) {
    if (!rootGetters['auth/hasModule'].appointments) {
      return
    }
    if (rootGetters['auth/hasModule'].competitions) {
      dispatch('competitions/updateCompetitions', null, { root: true })
    }
    if (rootGetters['auth/hasModule'].courses) {
      dispatch('courses/updateCourses', null, { root: true })
    }
    if (rootGetters['auth/hasModule'].tests) {
      dispatch('tests/updateTests', null, { root: true })
    }
    if (rootGetters['auth/hasModule'].webinars) {
      dispatch('webinars/updateWebinars', null, { root: true })
    }
    AppointmentsAPI.getAppointments().then((data) => {
      const keyedAppointments = {}
      data.data.forEach((appointment) => {
        keyedAppointments[appointment.id] = appointment
      })
      commit('setAppointments', keyedAppointments)
      dispatch('scheduleRegistrationDeadlineRefresh')
    })
  },
  scheduleRegistrationDeadlineRefresh({ commit, state }) {
    if (registrationDeadlineRefreshCleanup) {
      registrationDeadlineRefreshCleanup()
    }

    registrationDeadlineRefreshCleanup = scheduleParticipationDeadlineTransitions(
      Object.values(state.appointments)
        .filter((appointment) => appointment.participation_management_enabled && !appointment.is_cancelled)
        .map((appointment) => appointment.registration_deadline_expires_at),
      (deadlineNow) => commit('setDeadlineNow', deadlineNow),
    )
  },
}
